var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CalendarIcon",
      "size": "30"
    }
  }), _vm._v(" " + _vm._s(_vm.form.id ? 'Editar' : 'Cadastrar') + " Semana Epidemiológica ")], 1)])], 1)], 1)], 1)], 1), _c('b-card', [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome",
      "label-for": "descricao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "descricao",
      "placeholder": "Ex: Semana 01/2024",
      "required": ""
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data Início",
      "label-for": "dataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "dataInicio",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.dataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataInicio", $$v);
      },
      expression: "form.dataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data Fim",
      "label-for": "dataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "dataFim",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.dataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataFim", $$v);
      },
      expression: "form.dataFim"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-2 text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary",
      "to": '/SemanaEpidemiologicaLista'
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Salvar ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }